import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as expressionNode from '../../node'
import { Instance } from '../instance'

export type Node<T extends Instance = Instance> = expressionNode.ForValue<T>
export namespace Node {
  export const isNode: TypeChecker<Node> = TypeChecker.Factory.custom(
    (val: unknown): val is Node =>
      expressionNode.ForValue.isForValue(val) && Instance.isInstance(val.value),
    {
      typeDescription: 'dms.Instance.Node',
    },
  )
  export const assertIsNode: TypeAsserter<Node> =
    TypeAsserter.Factory.from(isNode)
}
